// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SuggestedVehiclesWrapper_wrapper__nk_Lj","innerCmpnt":"SuggestedVehiclesWrapper_innerCmpnt__ZjxfO"};